export default __webpack_public_path__ + "static/media/kitchen-timer.1a31a416.mp3";